import { render } from "./UsersCompany.vue?vue&type=template&id=d0b0ccc6&scoped=true&ts=true"
import script from "./UsersCompany.ts?vue&type=script&lang=ts"
export * from "./UsersCompany.ts?vue&type=script&lang=ts"

import "./UsersCompany.vue?vue&type=style&index=0&id=d0b0ccc6&scoped=true&lang=scss"

import exportComponent from "D:\\OdocsPortal\\odocsportal-frontend-master\\odocsportal-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0b0ccc6"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QAvatar,QImg});
